export const SUBSCRIPTION_REQUESTS_API = "subscriptionRequests/";
